export enum ReportContentScoreTypes {
  PPA = 'PPA',
  PBA = 'PBA',
  PFA = 'PFA',
}
